// Add any root level React Providers here
import { StrictMode, type ReactNode } from 'react';
// see https://go/mdswebui for more information
import { Theme } from '@mds/web-ui-theme';
// The default brand is Chase Master Brand (CMB), but you may be using a different brand:
// jmb, cpo, cpc, bcb, or jpo.
import '@mds/web-ui-theme/cmb';

interface AppProvidersProps {
  children: ReactNode;
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <StrictMode>
      <Theme brand="cmb">{children}</Theme>
    </StrictMode>
  );
}

export default AppProviders;
